/*
  PARCHE NEW ERA (velocidad, 04/11) — complementarios de la ficha, diferidos.

  Antes los embudos de Daniel se calculaban dentro de main-product, arriba en el HTML,
  y retrasaban cada ficha 150-250 ms en el servidor. Ahora main-product deja un
  esqueleto (snippets/complementary-esqueleto) y este elemento pide
  sections/complementary-diferidos en cuanto el documento termina de llegar, con
  prioridad baja para no competir con la imagen principal. Mismas recomendaciones: el
  snippet de Daniel no cambia.
*/
(() => {
  class ComplementaryDiferidos extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;
      fetch(this.dataset.url, { priority: 'low' })
        .then((r) => {
          if (!r.ok) throw new Error(`HTTP ${r.status}`);
          return r.text();
        })
        .then((html) => this.pintar(html))
        .catch(() => this.vaciar());
    }

    pintar(html) {
      if (!this.isConnected) return;
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const bloque = tmp.querySelector('.complementary-products-dan');
      if (!bloque || !bloque.querySelector('.product-block')) {
        this.vaciar();
        return;
      }
      // Los ajustes del bloque (maximo y carrusel) viven en la ficha, no en la seccion
      // que se pide: se aplican aqui. La seccion pide siempre hasta 4, el tope del snippet.
      const max = parseInt(this.dataset.max, 10) || 4;
      const tarjetas = [...bloque.querySelectorAll('.product-block')];
      tarjetas.slice(max).forEach((t) => {
        (t.closest('.slider__item, .columna-producto-complementario') || t).remove();
      });
      const quedan = tarjetas.slice(0, max);
      const conCarrusel = this.dataset.carousel === 'true' && quedan.length > 2;
      if (!conCarrusel && bloque.querySelector('carousel-slider')) {
        this.aRejilla(bloque, quedan);
      }

      const titulo = bloque.querySelector('.label');
      if (titulo) titulo.textContent = this.dataset.heading || '';
      this.replaceChildren(bloque);
      this.removeAttribute('aria-busy');
    }

    // La misma rejilla de 2 columnas que pinta complementary-products-dan sin carrusel.
    aRejilla(bloque, tarjetas) {
      const fila = bloque.querySelector('.lightly-spaced-row');
      if (!fila) return;
      const cabecera = document.createElement('div');
      cabecera.className = 'very-lightly-spaced-row';
      const label = document.createElement('div');
      label.className = 'label';
      cabecera.append(label);
      const rejilla = document.createElement('div');
      rejilla.className = 'fixed-layout fixed-layout--no-wide-gutter contenedor-productos-complementarios';
      tarjetas.forEach((t) => {
        const col = document.createElement('div');
        col.className = 'column column--half columna-producto-complementario';
        col.append(t);
        rejilla.append(col);
      });
      fila.replaceChildren(cabecera, rejilla);
    }

    vaciar() {
      if (!this.isConnected) return;
      this.replaceChildren();
      this.removeAttribute('aria-busy');
      this.hidden = true;
    }
  }

  if (!customElements.get('complementary-diferidos')) {
    customElements.define('complementary-diferidos', ComplementaryDiferidos);
  }
})();
